export default function noop() {}



//////////////////
// WEBPACK FOOTER
// ../~/d3-geo/src/noop.js
// module id = DUih
// module chunks = 0